module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"packets":"Form Packets","englishForms":"English Forms","allForms":"All Forms","placeHolder":"Enter name/number to search for forms","spanishForms":"Bilingual Forms"},"es":{"packets":"Paquetes de Formulario","englishForms":"Formularios en inglés","allForms":"Todas las Formas","placeHolder":"Ingrese nombre/número para buscar formularios","spanishForms":"Bilingual Forms"}}')
  delete Component.options._Ctor
}
